import { useAuth } from "contexts/AuthContext";

export const WelcomeMessageSection = () => {
  const { user } = useAuth();
  const firstName = user?.first_name?.trim();
  const username = user?.username?.trim();
  const fallback = username?.split(/[._-]/).filter(Boolean)[0];
  const displayName = firstName || (fallback ? fallback.charAt(0).toUpperCase() + fallback.slice(1) : "there");
  const date = new Intl.DateTimeFormat("en-US", {
    weekday: "long", month: "long", day: "numeric", timeZone: user?.timezone || undefined,
  }).format(new Date());

  return (
    <header className="home-welcome">
      <p className="home-eyebrow">{date}</p>
      <h1>Welcome to the climb, {displayName}.</h1>
      <p>Make a little room for what matters.</p>
      <svg className="home-welcome__contours" viewBox="0 0 300 180" fill="none" aria-hidden="true">
        {[0, 1, 2, 3, 4, 5].map((line) => (
          <path key={line} d={`M ${-30 + line * 18} 180 C ${30 + line * 16} 140, ${40 + line * 14} ${20 - line * 5}, 170 ${30 + line * 11} S 260 ${100 + line * 9}, 320 ${line * 15}`} />
        ))}
      </svg>
    </header>
  );
};
